/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useUserUpdateContext } from '../../contexts/UserContext';
import { useCallback } from 'react';
import { getProfile } from '../../rest/authClient';
import { RestError } from '@ax2/common/rest/baseClient';

export const useAuth = (
  redirect: boolean,
  deps: any[] = []
): (() => Promise<boolean>) => {
  const updateUser = useUserUpdateContext();
  return useCallback(() => {
    return getProfile(redirect)
      .then(authResponse => {
        updateUser(authResponse);
        return true;
      })
      .catch((e: RestError) => {
        if (e.category === 'Api' && e.reason === 'AuthorizationFailed') {
          return false;
        }
        throw e;
      });
  }, deps);
};
